let $ = require('jquery');
let Vue = require('vue');

Vue.directive('check', {
    twoWay: true,
    priority: 1000,

    params: ['onChange'],

    bind: function () {
        let self = this;
        $(this.el).on('change', function () {
            self.set($(this).is(':checked'))
            if (self.params.onChange) {
                self.params.onChange();
            }
        });
    },
    update: function (value) {
        $(this.el)
            .prop('checked', !!value);
        $(this.el).uniform();
    },
    unbind: function () {
        //$(this.el).off().select2('destroy')
    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/check.js